module.exports = __webpack_public_path__ + "img/mediale_dx.85f76f2b.png";